export default "__VITE_ASSET__254e69d6__"